import { render, staticRenderFns } from "./TechnicalSpecification.vue?vue&type=template&id=3685d02c&scoped=true&"
import script from "./TechnicalSpecification.vue?vue&type=script&lang=js&"
export * from "./TechnicalSpecification.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalSpecification.vue?vue&type=style&index=0&id=3685d02c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3685d02c",
  null
  
)

export default component.exports